import { RootState } from 'store';
import { IJobApplicantLink } from 'types/employee/IJobApplicantLink';

export const jobApplicantLinksSelector = (state: RootState): IJobApplicantLink[] => state.jobApplicantLinks.links;

export const jobApplicantLinksLoadingSelector = (state: RootState): boolean => state.jobApplicantLinks.loading;

export const jobApplicantLinkErrorSelector = (state: RootState): string | null => state.jobApplicantLinks.error;

export const jobApplicantLinkRejectedLocationIdsSelector = (state: RootState): number[] =>
  state.jobApplicantLinks.rejectedLocationIds;

export const jobApplicantLinkSuccessSelector = (state: RootState): boolean => state.jobApplicantLinks.success;

/**
 * Admin-only per-company feature state. Selected as two primitives rather than one object so
 * useAppSelector compares by value — returning a fresh object here would re-render on every
 * store change.
 */
export const jobApplicantFeatureCompanyIdSelector = (state: RootState): number | null =>
  state.jobApplicantLinks.featureCompanyId;

export const jobApplicantFeatureEnabledSelector = (state: RootState): boolean => state.jobApplicantLinks.featureEnabled;
